export const REQUEST_CLASS = 'htmx-request';

const DISABLED_MARKER   = 'data-disabled-by-htmx';
const INTERNAL_DATA_KEY = 'htmx-internal-data';

const resetRequestCount = element => {
    element[INTERNAL_DATA_KEY].requestCount = 0;
};

export const releaseFrozenRequestState = () => {
    document.querySelectorAll(`.${REQUEST_CLASS}`).forEach(element => {
        resetRequestCount(element);
        element.classList.remove(REQUEST_CLASS);
    });

    document.querySelectorAll(`[${DISABLED_MARKER}]`).forEach(element => {
        resetRequestCount(element);
        element.removeAttribute('disabled');
        element.removeAttribute(DISABLED_MARKER);
    });
};
